export const lock = () => {
  document.body.style.overflow = 'hidden';
};

export const unlock = () => {
  document.body.style.overflow = 'auto';
};
